import { HUD } from '../../config/tuning';
import type { HudPainter } from '../HudLayout';

/**
 * The centre reticle (SPEC §3.4.1): a hollow shield outline, apex up, fixed at screen centre.
 *
 * It marks the boresight — where the camera is pointed — and never moves. Its whole job is to be
 * the fixed thing the flight path marker is read against: the gap between the two *is* the angle
 * of attack, and that gap is the most important reading on the display.
 */
export function drawReticle(painter: HudPainter): void {
  const layout = painter.layout;
  const ctx = painter.ctx;

  const height = layout.px(HUD.reticleHeightPx);
  const halfHeight = height * 0.5;
  const halfWidth = height * 0.36;
  const shoulder = -halfHeight + height * 0.3;
  const waist = height * 0.12;

  ctx.save();
  ctx.translate(layout.centreX, layout.centreY);

  ctx.beginPath();
  ctx.moveTo(0, -halfHeight);
  ctx.lineTo(halfWidth, shoulder);
  ctx.lineTo(halfWidth * 0.82, waist);
  ctx.lineTo(0, halfHeight);
  ctx.lineTo(-halfWidth * 0.82, waist);
  ctx.lineTo(-halfWidth, shoulder);
  ctx.closePath();
  painter.stroke();

  ctx.restore();
}
